import styled from "styled-components";
import { useRef, useEffect, useState } from "react";
import { RefObject } from "react";
import { TopicElement } from "shared/types";

interface Props {
  data: TopicElement;
}

export default function LargeHeader({ data }: Props) {
  const [height, setHeight] = useState(0);
  const H2Ref: RefObject<HTMLHeadingElement> = useRef(null);

  useEffect(() => {
    if (!height) {
      setHeight(H2Ref.current!.clientHeight);
    }
  }, [height, H2Ref]);

  return (
    <Wrapper>
      <Decoration height={height} />
      <H2 id={data.title} ref={H2Ref}>
        {data.title}
      </H2>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Decoration = styled.div<{ height: number }>`
  background: linear-gradient(#e68ab4, #a84fb2);
  width: 4px;
  min-height: 31px;
  height: ${({ height }) => height}px;
  margin-right: 8px;
`;

const H2 = styled.h2`
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.53px;
  line-height: 28px;
  color: #3c424a;
`;
